<mat-card class="detail-card" valumizeCardContextMenu [commentSlug]="'deal-funds'">
  @let dealFunds = dealFunds$ | async;
  @let dealId = dealId$ | async;
  <mat-card-header class="detail-card-header">
    <mat-card-title data-test="title">Funds (in Deal Currency)</mat-card-title>
  </mat-card-header>
  <mat-card-content class="detail-card-content">
    <section class="table-container deal-funds-sticky-scroll" tabindex="0">
      @if (isExchangeRateMissing$ | async) {
        <valumize-info-panel [appearance]="'WARNING'" [message]="'Please add missing exchange rates.'"></valumize-info-panel>
      }
      @if (dealFunds) {
        @if (dealFundsForm) {
          <form [formGroup]="dealFundsForm">
            <table mat-table [dataSource]="dealFundsDataSource" matSort #dealFundsSort="matSort">
              <ng-container matColumnDef="fundName" sticky>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Fund Name</th>
                <td mat-cell *matCellDef="let element" class="no-wrap">
                  @if (element.isArchived?.value) {
                    <mat-icon class="archived-icon">inventory_2</mat-icon>
                  }
                  {{element.fundName | traceableFormat}}
                </td>
              </ng-container>

              <!-- ==================== Fund Details ==================== -->

              <ng-container matColumnDef="fundValuationDescription">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('fundValuationDescription')">Description</th>
                <td mat-cell *matCellDef="let element"
                    [class.grp-start-data]="isGroupStart('fundValuationDescription')">
                  <div class="ellipsis">
                      @if (!noValueCell(element, 'allFooter')){
                        {{element.fundValuationDescription | traceableFormat}}
                      }
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="fundSize">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('fundSize')">Fund Size*</th>
                <td mat-cell *matCellDef="let element"
                    [class.grp-start-data]="isGroupStart('fundSize')">
                    @if (!noValueCell(element, 'allFooter')){
                        {{element.fundSize | traceableFormat}}
                    }
                </td>
              </ng-container>
              <ng-container matColumnDef="fundCurrency">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('fundCurrency')">Fund Currency</th>
                <td mat-cell *matCellDef="let element"
                    [class.grp-start-data]="isGroupStart('fundCurrency')">
                    @if (!noValueCell(element, 'allFooter')){
                        {{element.fundCurrency.code | codeFormat: codeTableCurrency | async}}
                    }
                </td>
              </ng-container>
              <ng-container matColumnDef="exchangeRate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('exchangeRate')">Exchange Rate</th>
                <td mat-cell *matCellDef="let element" [ngClass]="{'bg-exchange-rate-warning': (!element.exchangeRate.fraction && (element.fundId > 0))}"
                    [class.grp-start-data]="isGroupStart('exchangeRate')">
                  @if (!isEditable && !noValueCell(element, 'allFooter')) {
                    {{element.exchangeRate.fraction | decimalFormat: "number"}}
                  } @else {
                    @if (dealFundsForm.controls[element.fundName.text + 'ExchangeRate']) {
                      <input matInput
                        class="input-number-narrow"
                        type="number"
                        (click)="$event.stopPropagation()"
                        formControlName="{{element.fundName | traceableFormat}}ExchangeRate"
                        id="{{element.fundName | traceableFormat}}ExchangeRate">
                      <button mat-icon-button
                              type="button"
                              class="fx-refresh-button"
                              matTooltip="Reload latest ECB rate"
                              (click)="$event.stopPropagation(); refreshRow(element.fundName.text)">
                        <mat-icon>sync</mat-icon>
                      </button>
                      @if (fxAsOfDate[element.fundName.text]) {
                        @if (autofilledUntouched[element.fundName.text]) {
                          <div class="fx-asof">as of {{ fxAsOfDate[element.fundName.text] | date }}</div>
                        } @else {
                          <div class="fx-asof">User edited on {{ fxEditedDate[element.fundName.text] | date }}</div>
                        }
                      }
                    }
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="fundSizeInDealCurrency">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('fundSizeInDealCurrency')">Fund Size</th>
                <td mat-cell *matCellDef="let element"
                    [class.grp-start-data]="isGroupStart('fundSizeInDealCurrency')">
                    @if (!noValueCell(element, 'bidPrAdj')){
                        {{element.fundSizeInDealCurrency | traceableFormat}}
                    }
                </td>
              </ng-container>
              <ng-container matColumnDef="fundVintageYear">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('fundVintageYear')">Fund Vintage Year</th>
                <td mat-cell *matCellDef="let element"
                    [class.grp-start-data]="isGroupStart('fundVintageYear')">
                    @if (!noValueCell(element, 'allFooter')){
                        {{element.fundVintageYear | traceableFormat}}
                    }
                </td>
              </ng-container>
              <ng-container matColumnDef="fundEndYear">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('fundEndYear')">Fund End Year</th>
                <td mat-cell *matCellDef="let element"
                    [class.grp-start-data]="isGroupStart('fundEndYear')">
                    @if (!noValueCell(element, 'allFooter')){
                        {{element.fundEndYear | traceableFormat}}
                    }
                </td>
              </ng-container>
              <ng-container matColumnDef="fundStage">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('fundStage')">Fund Stage</th>
                <td mat-cell *matCellDef="let element"
                    [class.grp-start-data]="isGroupStart('fundStage')">
                    @if (!noValueCell(element, 'allFooter')){
                        {{element.fundStage.code | codeFormat: codeTableStage | async}}
                    }
                </td>
              </ng-container>

              <!-- ==================== Fund Report (Seller) Detail ==================== -->

              <ng-container matColumnDef="reportDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header [class.grp-start-data]="isGroupStart('reportDate')">Report Date</th>
                <td mat-cell *matCellDef="let element" [class.grp-start-data]="isGroupStart('reportDate')">
                    @if (!noValueCell(element, 'allFooter')){
                        {{element.reportDate | traceableFormat}}
                    }
                </td>
              </ng-container>
              <ng-container matColumnDef="sellerStake">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('sellerStake')">Seller<br>Stake</th>
                <td mat-cell *matCellDef="let element"
                    [class.grp-start-data]="isGroupStart('sellerStake')">
                    @if (!noValueCell(element, 'allFooter')){
                        {{element.sellerPosition.sellerStake | traceableFormat}}
                    }
                </td>
              </ng-container>
              <ng-container matColumnDef="sellerCommitment">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('sellerCommitment')">Seller<br>Commitment*</th>
                <td mat-cell *matCellDef="let element"
                    [class.grp-start-data]="isGroupStart('sellerCommitment')">
                    @if (!noValueCell(element, 'allFooter')){
                        {{element.sellerPosition.sellerCommitment | traceableFormat}}
                    }
                </td>
              </ng-container>
              <ng-container matColumnDef="sellerCommitmentDealCurrency">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('sellerCommitmentDealCurrency')">Seller<br>Commitment</th>
                <td mat-cell *matCellDef="let element"
                    [class.grp-start-data]="isGroupStart('sellerCommitmentDealCurrency')">
                    @if (!noValueCell(element, 'bidPrAdj')){
                        {{element.sellerCommitmentDealCurrency | traceableFormat}}
                    }
                </td>
              </ng-container>
              <ng-container matColumnDef="nTvpi">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('nTvpi')">Current<br>nTVPI</th>
                <td mat-cell *matCellDef="let element"
                    [class.grp-start-data]="isGroupStart('nTvpi')">
                    @if (!noValueCell(element, 'bidPrAdj')){
                        {{element.nTvpi | traceableFormat}}
                    }
                </td>
              </ng-container>
              <ng-container matColumnDef="breakevenMoic">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('breakevenMoic')">Breakeven<br>MOIC</th>
                <td mat-cell *matCellDef="let element"
                    [class.grp-start-data]="isGroupStart('breakevenMoic')">
                    @if (!noValueCell(element, 'bidPrAdj')){
                        {{element.breakevenMoic | traceableFormat}}
                    }
                </td>
              </ng-container>
              <ng-container matColumnDef="navWeightedGpEvEbitda">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('navWeightedGpEvEbitda')">NAV Weighted<br>EV/EBITDA</th>
                <td mat-cell *matCellDef="let element"
                    [class.grp-start-data]="isGroupStart('navWeightedGpEvEbitda')">
                    @if (!noValueCell(element, 'bidPrAdj')){
                        {{element.navWeightedGpEvEbitda | traceableFormat}}
                    }
                </td>
              </ng-container>

              <!-- ==================== Forecast (Buyer) Detail ==================== -->

              <ng-container matColumnDef="closingDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header [class.grp-start-data]="isGroupStart('closingDate')">Closing Date</th>
                <td mat-cell *matCellDef="let element" [class.grp-start-data]="isGroupStart('closingDate')">
                    @if (!noValueCell(element, 'allFooter')){
                        {{element.closingDate | traceableFormat}}
                    }
                </td>
              </ng-container>
              <ng-container matColumnDef="buyerStake">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('buyerStake')">Buyer<br>Stake</th>
                <td mat-cell *matCellDef="let element"
                    [class.grp-start-data]="isGroupStart('buyerStake')">
                  @if (!isEditable && !noValueCell(element, 'allFooter')) {
                    {{element.sellerPosition.buyerStake | traceableFormat}}
                  } @else {
                    @if (dealFundsForm.controls[element.fundName.text + 'BuyerStake']) {
                      <input matInput
                        class="input-number-narrow"
                        type="number"
                        (click)="$event.stopPropagation()"
                        formControlName="{{element.fundName | traceableFormat}}BuyerStake"
                        id="{{element.fundName | traceableFormat}}BuyerStake">
                    }
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="buyerCommitment">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('buyerCommitment')">Buyer<br>Commitment</th>
                <td mat-cell *matCellDef="let element"
                    [class.grp-start-data]="isGroupStart('buyerCommitment')">
                    @if (!noValueCell(element, 'bidPrAdj')){
                        {{element.sellerPosition.buyerCommitment | traceableFormat}}
                    }
                </td>
              </ng-container>
              <ng-container matColumnDef="discountToNav">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('discountToNav')">Discount to NAV</th>
                <td mat-cell *matCellDef="let element"
                    [class.grp-start-data]="isGroupStart('discountToNav')">
                    @if (!noValueCell(element, 'bidPrAdj')){
                        {{element.discountToNav | traceableFormat}}
                    }
                </td>
              </ng-container>
              <ng-container matColumnDef="bidPriceBuyerStake">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('bidPriceBuyerStake')">Bid Price<br>(Buyer Stake)</th>
                <td mat-cell *matCellDef="let element"
                    [class.grp-start-data]="isGroupStart('bidPriceBuyerStake')">
                  @if (!isEditable) {
                    {{element.bidPriceBuyerStake | traceableFormat}}
                  } @else {
                    @if (isEditableBidColumnCell(element.fundName.text) && !!dealId) {
                      <input matInput
                        class="input-number-narrow"
                        type="number"
                        (click)="$event.stopPropagation()"
                        formControlName="bidPriceAdjustment"
                        id="bidPriceAdjustment">
                    }
                    @if (!isEditableBidColumnCell(element.fundName.text)) {
                      {{element.bidPriceBuyerStake | traceableFormat}}
                    }
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="navBuyerStake">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('navBuyerStake')">NAV<br>(Buyer Stake)</th>
                <td mat-cell *matCellDef="let element"
                    [class.grp-start-data]="isGroupStart('navBuyerStake')">
                    @if (!noValueCell(element, 'bidPrAdj')){
                        {{element.navBuyerStake | traceableFormat}}
                    }
                </td>
              </ng-container>
              <ng-container matColumnDef="unfundedBuyerStake">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('unfundedBuyerStake')">Unfunded<br>(Buyer Stake)</th>
                <td mat-cell *matCellDef="let element"
                    [class.grp-start-data]="isGroupStart('unfundedBuyerStake')">
                    @if (!noValueCell(element, 'bidPrAdj')){
                        {{element.unfundedBuyerStake | traceableFormat}}
                    }
                </td>
              </ng-container>
              <ng-container matColumnDef="exposureBuyerStake">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('exposureBuyerStake')">Exposure<br>(Buyer Stake)</th>
                <td mat-cell *matCellDef="let element"
                    [class.grp-start-data]="isGroupStart('exposureBuyerStake')">
                    @if (!noValueCell(element, 'bidPrAdj')){
                        {{element.exposureBuyerStake | traceableFormat}}
                    }
                </td>
              </ng-container>
              <ng-container matColumnDef="adjustedCommitment">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [class.grp-start-data]="isGroupStart('adjustedCommitment')">Secondary<br>Commitment</th>
                <td mat-cell *matCellDef="let element"
                    [class.grp-start-data]="isGroupStart('adjustedCommitment')">
                    @if (!noValueCell(element, 'bidPrAdj')){
                        {{element.adjustedCommitment | traceableFormat}}
                    }
                </td>
              </ng-container>

              <!-- ==================== Group header column definitions ==================== -->

              @for (band of groupBands; track band.id) {
                <ng-container [matColumnDef]="band.id" [sticky]="band.id === 'band-0'">
                  <th mat-header-cell *matHeaderCellDef
                      [attr.colspan]="band.colspan"
                      [class.grp-start]="band.isStart">
                    @if (band.label) {
                      <span class="grp-label">{{ band.label }}</span>
                    }
                  </th>
                </ng-container>
              }

              <tr mat-header-row *matHeaderRowDef="groupBandIds; sticky: true" class="col-group-header-row"></tr>
              <tr mat-header-row *matHeaderRowDef="dealFundsColumns; sticky: true"></tr>
              <tr mat-row
                *matRowDef=" let row; columns: dealFundsColumns"
                class="{{styleRowImportant(row)}} {{styleRowBorderTop(row)}} {{styleRowNotClickable(row)}} {{notClickableInEditMode()}}"
                [routerLink]="'../../funds/' + row.fundId"
                                [queryParams]="{
                                    fundReportId: row.fundReportId,
                                    fundValuationId: row.fundValuationId,
                                    dealId: dealId
                                }"
              ></tr>
            </table>
          </form>
        }
      }
    </section>
    <mat-paginator [pageSize]="savedPageSize" [pageSizeOptions]="[10, 20, 30, 50, 100]" showFirstLastButtons></mat-paginator>
    <br>
      <section>* Fund Currency</section>
    </mat-card-content>
    <mat-card-actions class="detail-card-actions">
      @if (dealId) {
        @let selectedCcy = selectedDealCurrency$ | async;
        <button mat-icon-button
          color="primary"
          (click)="openManageFundsDialog(dealId)"
          matTooltip="Manage Funds"
          data-test="manage-funds">
          <mat-icon>settings</mat-icon>
        </button>
        <button mat-icon-button
          class="manage-fx-rates-button"
          color="primary"
          (click)="openFxRatesDialog(dealId)"
          [disabled]="!selectedCcy"
          [matTooltip]="!selectedCcy ? 'Set deal currency first' : 'Manage FX rates'"
          data-test="manage-fx-rates">
          <mat-icon>currency_exchange</mat-icon>
        </button>
        <button mat-icon-button
          color="primary"
          (click)="openTableSettings()"
          matTooltip="Table Settings"
          data-test="table-settings">
          <mat-icon>view_column</mat-icon>
        </button>
        @if (!isEditable) {
          <button (click)="editMode()"
            [disabled]="(isEditDisabled$ | async)!"
            color="primary"
            data-test="edit-button"
            mat-icon-button>
            <mat-icon>edit</mat-icon>
          </button>
        }
        @if (dealFunds) {
          @if (isEditable) {
            <button (click)="save(dealId, dealFunds.tableDatasource)"
              color="primary"
              data-test="save-button"
              mat-icon-button>
              <mat-icon>save</mat-icon>
            </button>
          }
        }
        @if (isEditable) {
          <button (click)="cancel()"
            color="primary"
            data-test="cancel-button"
            mat-icon-button>
            <mat-icon>cancel</mat-icon>
          </button>
        }
      }
      <valumize-card-comments-button [commentSlug]="'deal-funds'"></valumize-card-comments-button>
    </mat-card-actions>
  </mat-card>


